import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const COLLECTION_PREFERENCES = 'Collection preferences';

export const SP_SELLER_COLLECTION_PREFERENCE = Object.freeze({

  COLLECTION_PREFERENCES_DATE_CLICKED: (selected: boolean, label: string) =>
    GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: COLLECTION_PREFERENCES,
      label,
      name: selected ? 'Date chip selected' : 'Date chip deselected',
    }),

  COLLECTION_PREFERENCES_DATES_SUBMITTED: () =>
    GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
      button_label: 'Submit request',
      category: COLLECTION_PREFERENCES,
      label: 'Submit button clicked',
      name: 'collection_preferences_dates_submitted',
      success: false,
      url: 'N/A',
    }),

  COLLECTION_PREFERENCES_DATES_UNAVAILABLE: (dates: string) =>
    GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
      button_label: 'Submit request',
      category: COLLECTION_PREFERENCES,
      label: dates,
      name: 'collection_preferences_dates_unavailable',
      success: false,
      url: 'N/A',
    }),

  COLLECTION_PREFERENCES_PAGE: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: COLLECTION_PREFERENCES,
    label: 'Page loaded',
    name: 'collection_preferences_page',
  }),
});
